<section class="area-login animate__animated animate__fadeIn" [ngStyle]="{ 'background-image': 'url(' + randomImage + ')' }">
  <mat-card class="login" style="position: relative;">
    <mat-card-content>

      <div class="simpli-floating-box-header">

        <div class="simpli-floating-box-logo text-center" (click)="dialog_success()">
          <img src="../../assets/simpli/simplilogo2.svg" height="90px">
        </div>
        @if (paso1) {
          <div class="simpli-floating-box-title text-center">
            <span class="color-tertiary">Regístrate de forma <strong class="color-tertiary" style="color:var(--simpli-secondary) !important;">Simpli</strong></span>
          </div>
        }
        @if (paso2) {
          <div class="simpli-floating-box-title text-center">
            <span class="color-tertiary">Ingresa tus datos de contacto</span>
          </div>
        }
      </div>

      <div class="simpli-floating-box-body">
        @if (paso1) {
          <div class="animate__animated animate__fadeIn">
            <form [formGroup]="valForm" (submit)="submitFormCompany($event, valForm.value)" autocomplete="off">
              <mat-form-field appearance="fill">
                <mat-label>Correo electrónico</mat-label>
                <input type="email" matInput required autocomplete="email" formControlName="username" (blur)="changeMail($event)" autocomplete="off">
                @if (this.show_spinner_mail) {
                  <mat-spinner color="primary" style="margin-right: 10px;" matSuffix diameter="20"></mat-spinner>
                }
                <mat-hint>Ingresa tu correo electrónico</mat-hint>
                @if (valForm.controls['username'].hasError('required') && (valForm.controls['username'].dirty || valForm.controls['username'].touched)) {
                  <mat-error>
                    Este campo es <strong>obligatorio</strong>
                  </mat-error>
                }
                @if (valForm.controls['username'].hasError('pattern')) {
                  <mat-error>
                    Debe ser un correo electrónico valido
                  </mat-error>
                }
                @if (valForm.controls['username'].hasError('incorrect')) {
                  <mat-error>
                    Correo electrónico ya en uso
                  </mat-error>
                }
              </mat-form-field>
              <mat-form-field appearance="fill">
                <mat-label>Contraseña</mat-label>
                <input matInput formControlName="password" autocomplete="password" [type]="hide ? 'password' : 'text'" required  autocomplete="new-name">
                <button matSuffix mat-icon-button type="button" (click)="hide = !hide" [attr.aria-label]="'Ocultar password'"
                  [attr.aria-pressed]="hide">
                  <mat-icon class="simpli-color-gris">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                </button>
                <mat-hint>Crea tu contraseña</mat-hint>
                @if (valForm.controls['password'].hasError('required') && (valForm.controls['password'].dirty || valForm.controls['password'].touched)) {
                  <mat-error>
                    Este campo es <strong>obligatorio</strong>
                  </mat-error>
                }
                @if (valForm.controls['password'].hasError('minlength')) {
                  <mat-error>
                    Debe contener un mínimo de 6 caracteres
                  </mat-error>
                }
              </mat-form-field>
              <mat-form-field appearance="fill">
                <mat-label>Repite contraseña</mat-label>
                <input matInput formControlName="password_confirmation" [type]="hideRe ? 'password' : 'text'" required  name="password" autocomplete="new-password">
                <button matSuffix mat-icon-button type="button" (click)="hideRe = !hideRe" [attr.aria-label]="'Ocultar password'"
                  [attr.aria-pressed]="hideRe">
                  <mat-icon class="simpli-color-gris">{{hideRe ? 'visibility_off' : 'visibility'}}</mat-icon>
                </button>
                <mat-hint>Vuelve a introducir tu contraseña</mat-hint>
                @if (valForm.controls['password_confirmation'].hasError('required') && (valForm.controls['password_confirmation'].dirty || valForm.controls['password_confirmation'].touched)) {
                  <mat-error>
                    Este campo es <strong>obligatorio</strong>
                  </mat-error>
                }
                @if (valForm.get('password_confirmation').hasError('equalTo')) {
                  <mat-error>
                    La contraseña ingresada no coincide
                  </mat-error>
                }
              </mat-form-field>
              <div class="btn-container">
                <button class="primary-button" [disabled]="show_spinner" mat-flat-button type="submit" color="primary" style="margin-right: 0px;">
                  @if (show_spinner == false) {
                    <mat-label>Continuar</mat-label>
                  }
                  @if (show_spinner == true) {
                    <span><span class="material-symbols-outlined mat-spin" style="color:var(--simpli-secondary);font-size: 18px;">progress_activity</span></span>
                  }
                </button>
              </div>
              <div class="center-div">
                @if (!valForm.controls['username'].hasError('incorrect')) {
                  <a mat-button class="label-button" routerLink="/login">Volver</a>
                }
                @if (valForm.controls['username'].hasError('incorrect')) {
                  <a mat-button class="label-button" (click)="referido()">Inicia sesión aqui</a>
                }
              </div>
            </form>
          </div>
        }

        @if (paso2) {
          <div class="animate__animated animate__fadeIn">
            <form [formGroup]="valFormCompany" (submit)="submitForm($event, valFormCompany.value)" autocomplete="off">
              <mat-form-field appearance="fill">
                <mat-label>Rut de empresa</mat-label>
                <input matInput type="text" required formControlName="rut" (keyup)="rutKey($event)" (change)="checkRut($event)" name="rut_empresa" autocomplete="new-rut_empresa">
                @if (display_spinner) {
                  <mat-spinner color="primary" style="margin-right: 10px;" matSuffix diameter="20"></mat-spinner>
                }
                <mat-hint>Ingresa tu RUT de Empresa sin puntos con guión</mat-hint>
                @if (valFormCompany.controls['rut'].hasError('required') && (valFormCompany.controls['rut'].dirty || valFormCompany.controls['rut'].touched)) {
                  <mat-error>
                    Este campo es <strong>obligatorio</strong>
                  </mat-error>
                }
                @if (valFormCompany.controls['rut'].hasError('invalid') || valFormCompany.controls['rut'].hasError('pattern')) {
                  <mat-error>El RUT ingresado no es válido</mat-error>
                }
              </mat-form-field>
              <mat-form-field appearance="fill">
                <mat-label>Nombre y Apellido</mat-label>
                <input matInput required formControlName="nombre" autocomplete="off">
                <mat-hint>Ingresa tu Nombre y Apellido</mat-hint>
                @if (valFormCompany.controls['nombre'].hasError('required') && (valFormCompany.controls['nombre'].dirty || valFormCompany.controls['nombre'].touched)) {
                  <mat-error>
                    Este campo es <strong>obligatorio</strong>
                  </mat-error>
                }
              </mat-form-field>
              <mat-form-field appearance="fill">
                <mat-label>Teléfono</mat-label>
                <input matInput required formControlName="telefono"  autocomplete="off" (change)="checkPhone($event)">
                <mat-hint>Ingresa un número de teléfono válido</mat-hint>
                @if (valFormCompany.controls['telefono'].hasError('required') && (valFormCompany.controls['telefono'].dirty || valFormCompany.controls['telefono'].touched)) {
                  <mat-error>
                    Este campo es <strong>obligatorio</strong>
                  </mat-error>
                }
                @if (valFormCompany.controls['telefono'].hasError('invalid')) {
                  <mat-error>El número de teléfono no es válido</mat-error>
                }
              </mat-form-field>
              @if (codigo != null) {
                <div class="codigo-aplicado">
                  <span>Código aplicado:</span>
                  <span class="codigo-aplicado-valor">
                    {{codigo}}
                    <button mat-icon-button type="button" (click)="delete()" aria-label="Quitar código">
                      <mat-icon>close</mat-icon>
                    </button>
                  </span>
                  @if (ejecutivo_referido) {
                    <span>Ejecutivo: {{ejecutivo_referido.nombre}} {{ejecutivo_referido.apellido}}</span>
                  }
                </div>
              }
              <div class="center-div">
                <a mat-button class="label-button" (click)="open_codigo()">
                  <span style="text-decoration: underline;">¿Tienes un código de referencia?</span>
                </a>
              </div>
              <div class="text-center mt-20">
                <small class="simpli-color3">
                  Al registrarte, estas aceptando nuestra
                  <a class="simpli-color2 cursor-pointer text-none" href="https://simplilatam.com/politica-de-privacidad/" target="_blank">Política de Privacidad</a>.
                  Además, enviaremos notificaciones por SMS. Si no deseas recibirlas, contacta a tu ejecutivo.
                </small>
              </div>
              <div class="btn-container">
                <button class="primary-button" [disabled]="show_spinner" mat-flat-button type="submit" color="primary" style="margin-right: 0px;">
                  @if (show_spinner == false) {
                    <mat-label>Registrarme</mat-label>
                  }
                  @if (show_spinner == true) {
                    <span><span class="material-symbols-outlined mat-spin" style="color:var(--simpli-secondary);font-size: 18px;">progress_activity</span></span>
                  }
                </button>
              </div>
              <div class="center-div">
                <a mat-button class="label-button" routerLink="/login">Volver</a>
              </div>
            </form>
          </div>
        }
      </div>


    </mat-card-content>

  </mat-card>
</section>
